import React from "react";
import PropTypes from "prop-types";
import styled from "styled-components";

import { BREAKPOINTS, COLORS } from "@onelogin/react-components";

const BarContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  background-color: ${props => props.theme.primaryColor};
  z-index: 2;
  border-bottom: solid 1px ${COLORS.SEPARATOR_COLORS.REGULAR};
  border-top-left-radius: 4px;
  border-top-right-radius: 4px;
  padding-top: 24px;
  padding-bottom: 24px;
  min-height: 60px;

  @media only screen and (max-width: ${BREAKPOINTS.PORTAL_MIDDLE}),
    only screen and (max-height: ${BREAKPOINTS.PHONE_LARGE}) {
    border-top-left-radius: 0;
    border-top-right-radius: 0;
    padding-top: 6px;
    padding-bottom: 6px;
    min-height: 40px;
  }
`;

const Logo = styled.img`
  display: block;
  margin: 0 auto;
  max-width: 280px;
  max-height: 60px;
  width: auto;
  height: auto;
  cursor: pointer;
  @media only screen and (max-width: ${BREAKPOINTS.PORTAL_MIDDLE}),
    only screen and (max-height: ${BREAKPOINTS.PHONE_LARGE}) {
    max-height: 40px;
  }
`;

const TopBar = ({ logoUrl }) => (
  <BarContainer>
    <a href="/">
      <Logo src={logoUrl} />
    </a>
  </BarContainer>
);

TopBar.propTypes = {
  logoUrl: PropTypes.string.isRequired
};

export default TopBar;
